// extracted by mini-css-extract-plugin
module.exports = {"root":"Rules_root__3EYcH"};